"use client";
import { Container, SectionSubHeading, SectionTitle } from "@/components";
import { fadeUp } from "@/lib/animation/variant";
import { motion } from "framer-motion";

const cultureData = [
  {
    id: 1,
    title: "Performance & Growth",
    description:
      "Every three (3) months, your performance will be reviewed based on technical excellence, communication, reliability, and overall contribution. High-performers are consistently recognized with career advancement opportunities and internal growth paths aligned with company vision.",
  },
  {
    id: 2,
    title: "Work Expectations",
    description:
      "As a remote team member, you are expected to maintain professional communication, attend scheduled meetings, and stay responsive during agreed working hours using official platforms.",
  },
  {
    id: 3,
    title: "Confidentiality & IP",
    description:
      "All company and client information must remain confidential. Any work produced—including code, designs, and prototypes—remains the exclusive property of Octarnal.",
  },
  {
    id: 4,
    title: "Leave Policy",
    description:
      "Employees may avail up to 15 days of leave per year, provided that leave is communicated and approved in advance whenever possible.",
  },
  {
    id: 5,
    title: "Resignation & Termination",
    description:
      "Either party may terminate agreement by providing 14 days written notice. Octarnal reserves the right for immediate termination in cases of misconduct or policy violations.",
  },
];

const CareerCulture = () => {
  return (
    <Container className="px-4 lg:px-10 flex flex-col lg:gap-16 md:gap-12 gap-8 md:py-16 py-10">
      {" "}
      <div>
        {/* Main Title Animation */}
        <motion.div
          variants={fadeUp}
          custom={0}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <SectionTitle title="Life At Octarnal" />
        </motion.div>

        {/* Main Subheading Animation */}
        <motion.div
          variants={fadeUp}
          custom={1}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <SectionSubHeading
            subtitle="We believe in fostering a dynamic and collaborative work environment that empowers our team to create digital excellence."
            className="max-w-3xl text-black/50 mt-4"
          />
        </motion.div>
      </div>
      {/* Main Content */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 lg:gap-y-12 gap-y-8">
        {cultureData.map((item, index) => (
          <motion.div
            key={item.id}
            variants={fadeUp}
            custom={index + 1}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.05 }}
            className={`lg:pt-12 pt-8 border-t border-black/5 flex flex-col gap-5`}
          >
            {/* Header with Title */}
            <h3 className="text-black text-xl md:text-2xl lg:text-3xl font-black tracking-tight leading-tight uppercase">
              {item.title}
            </h3>
            {/* Description Body */}
            <p className="text-black/50 text-base lg:text-lg leading-relaxed font-medium">
              {item.description}
            </p>
          </motion.div>
        ))}
      </div>
    </Container>
  );
};

export default CareerCulture;
